export type DiscardNavState = {
  discardConfirmed?: boolean
  discardMessage?: string
  sessionGoneMessage?: string
} | null

/**
 * Banner text for a worklist arrival carrying discard state — either a draft this
 * provider discarded from the editor, or one that was already gone when reopened.
 */
export function resolveDiscardNavMessage(navState: DiscardNavState): string | null {
  if (navState?.discardConfirmed) {
    return navState.discardMessage?.trim() || null
  }
  return navState?.sessionGoneMessage?.trim() || null
}
